import { configureStore, combineReducers } from '@reduxjs/toolkit'
import userReducer from './userSlice/userSlice'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'
import appReducer from './appSlice/appSlice'


const userPersistConfig = {
  key: 'user',
  storage: storage,
}


const rootReducers = combineReducers({
  user: persistReducer(userPersistConfig, userReducer), 
  app: appReducer, 
})

export const store = configureStore({
  reducer: rootReducers,
  middleware: [thunk],
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch